// extracted by mini-css-extract-plugin
export default {"secondaryOption":"HOVVA40pU2SpHJI9RG3c","image":"lSoGiu0i9vgMxMJDbEay"};